module.exports = __webpack_public_path__ + "img/double_arrow.260a4451.svg";